import { render, staticRenderFns } from "./GetPrizeDialog.vue?vue&type=template&id=46db35ce&scoped=true&"
import script from "./GetPrizeDialog.vue?vue&type=script&lang=js&"
export * from "./GetPrizeDialog.vue?vue&type=script&lang=js&"
import style0 from "./GetPrizeDialog.vue?vue&type=style&index=0&id=46db35ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db35ce",
  null
  
)

export default component.exports